module.exports = __webpack_public_path__ + "img/setting.5173bc29.png";